export default __webpack_public_path__ + "static/quote-1-979a57a360ad23692a799b218d488c4f.jpg";